import React from "react";
import Skeleton from "react-loading-skeleton"
import "react-loading-skeleton/dist/skeleton.css"

const SkeletonTile = ({ isInvestment = false }) => {
	return <div className={`flex border-1 border-radius align-center my-5`}>

		<div className={isInvestment ? "w-15":"w-18"}><Skeleton height={80} style={{ lineHeight: 2 }} /></div>
		<div className="flex justify-start w-30 p-2 px-4">
			<div className="flex-column w-100">
				<div className="w-70"><Skeleton /></div>
				<div className="w-40"><Skeleton /></div>
			</div>
		</div>
		<div className="flex w-40">
			<div className="flex-column w-100">
				<div className="pb-1"><div className="w-40"><Skeleton /> </div></div>
				<Skeleton />
			</div>
		</div>
	</div>
}

export default SkeletonTile;